import { render, staticRenderFns } from "./OnboardingSuggestions.vue?vue&type=template&id=322ce05c"
import script from "./OnboardingSuggestions.vue?vue&type=script&lang=js"
export * from "./OnboardingSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports